<template>
  <div class="memberActive">
    <div class="from_content">
      <div class="step2">
        <h2 v-if="!description">
          <img
            src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-upgrade-mini/home/courseTmall-icon.png"
            alt=""
          />
          <span>防伪码激活</span>
        </h2>
        <div class="error" v-if="description">
          <img
            src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-upgrade-mini/home/error.png"
            alt=""
          />
          <h5>激活失败</h5>
          <p>{{description}}</p>
        </div>
        <!-- 激活会员 -->
        <div>
          <van-field
            @input="getphoneValue"
            v-model.trim="tmallCard"
            type="input"
            placeholder="请输入防伪码"
          />
        </div>
      </div>
    </div>
    <div class="tmallBtn" :class="{ active: selected !== -1 }" @click="onClickTmall">点击激活</div>
    <Loading ref="load" />
    <CourseSuccess
      @courseChangeShow="courseChangeShow"
      :subCatalogId="subCatalogId"
      :productType="productType"
      :courseShow="courseShow"
    />
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import { mapState } from 'vuex';
import Loading from '@/components/loading/loading.vue';
import { reqcheckCode } from '@/api/personal/courseTmall';
import CourseSuccess from './courseSuccess.vue';

export default {
  components: {
    Loading,
    CourseSuccess,
  },
  data() {
    return {
      radio: '1',
      tmallCard: '',
      selected: -1,
      onShow: false,
      courseShow: false,
      subCatalogId: '', // 开课记录id
      productType: '', //
      description:''
    };
  },

  computed: {
    ...mapState(['userInfo']),
  },
  mounted() {},

  methods: {
    changeRadio() {
      this.tmallCard = '';
      this.selected = -1;
    },
    getphoneValue() {
      if (this.tmallCard) {
        this.selected = 0;
      } else {
        this.selected = -1;
      }
    },
    async onClickTmall() {
      if (!this.userInfo?.id) {
        this.toLogin();
        return;
      }
      if (!this.tmallCard) {
        this.$toast('请输入防伪码');
      } else {
        this.$refs.load.show = true;
        const res = await reqcheckCode({
          code: this.tmallCard,
          type: this.radio,
        });
        if (res.msg == '请求成功' && res.description != '该防伪码为正版') {
          // 验证成功
          this.courseShow = true;
          this.subCatalogId = res.data?.openCourseId;
          this.productType = res.data?.productType;
          this.description=""
        } else if (res.msg == '请求成功' && res.description == '该防伪码为正版') {
          // this.$toast(res.description);
          this.description=res.description;
        } else if (res.code == '19107') {
          // 您已有该课程
          // this.$toast('您已有该课程，请在app中查看');
          this.description="您已有该课程，请在app中查看"
        } else {
          this.description=res.msg;
        }
        this.$refs.load.show = false;
      }
    },
    // 去登录
    toLogin() {
      if (this.$root.miniprogram) {
        let url = window.location.href;
        const [domain, searchParams] = url.split('?');
        if (searchParams) {
          const params = searchParams.split('&');
          const paramsMap = new Map();
          params.forEach((item) => {
            const [key, value] = item.split('=');
            if (key) {
              paramsMap.set(key, value);
            }
          });
          const entries = paramsMap.entries();
          let query = '';
          const ExcludequeryArr = ['THIRD_SESSION', 'env'];
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of entries) {
            if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
          }
          url = `${domain}?${query}zsbCourseTmall=1`;
          const redirctUrl = encodeURIComponent(
            `/subPackages/detailWebView/index?url=${encodeURIComponent(url)}`,
          );
          const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
          wx.miniProgram.redirectTo({
            url: path,
          });
        }
      }
    },
    // 会员
    changeShow() {
      this.onShow = false;
    },
    // 课程
    courseChangeShow() {
      this.courseShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.memberActive {
  .from_content {
    width: 678px;
    height: 958px;
    margin: 0 auto;
    padding: 64px 60px 120px 60px;
    background: #fff;
    border-radius: 24px;
    box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.06);
    ::v-deep {
      .van-cell {
        padding: 0;
        .van-field__body {
          .van-field__control {
            width: 275px;
            height: 55px;
            padding-left: 16px;
            color: #333;
            font-weight: 400;
            font-size: 13px;
            background: #f8f9fb;
            border-radius: 9px;
          }
          input::-webkit-input-placeholder {
            color: #a5a5a5;
          }
        }
      }
      .van-radio-group--horizontal {
        justify-content: space-around;
        margin-bottom: 20px;
        .van-radio__label {
          font-size: 16px;
        }
      }
    }
  }
  .step2 {
    > h2 {
      display: flex;
      align-items: center;
      margin-bottom: 32px;
      span {
        padding-left: 7px;
        color: #333;
        font-weight: 500;
        font-size: 32px;
      }
      img {
        width: 36px;
        height: 36px;
      }
    }
  }
  .tmallBtn {
    position: fixed;
    right: 0;
    bottom: 60px;
    left: 0;
    width: 678px;
    height: 87px;
    margin: 0 auto;
    color: #fff;
    font-weight: 500;
    font-size: 29px;
    line-height: 87px;
    text-align: center;
    background: #ff7f41;
    border-radius: 43px;
    opacity: 0.5;
  }
  .tmallBtn.active {
    opacity: 1;
  }
  .error {
    text-align: center;
    img {
      width: 73px;
      height: 86px;
    }
    h5 {
      padding: 16px 0 43px 0;
      color: #333;
      font-weight: 500;
      font-size: 29px;
      text-align: center;
    }
    p {
      padding-bottom: 29px;
      color: #333;
      font-weight: 400;
      font-size: 25px;
      line-height: 36px;
      text-align: center;
    }
  }
}
</style>
